const moment = require("moment");
const { forIn } = require("lodash");

export function capitalize(data) {
    var capitalized = [];
    data.split(" ").forEach((word) => {
        capitalized.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    });
    return capitalized.join(" ");
}

export function addBusinesDayFromNow($numberOfBusinesDays) {
    var count = 0;
    var date = moment();
    while (count < $numberOfBusinesDays) {
        date.add(1, 'days');
        if (date.isoWeekday() < 6) {
            count++;
        }
    }
    return date;
}

export function normalize(str) {
    if (!str) return str;
    return str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}